import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    // useLocation nos avisa cada vez que la URL (pathname) cambia
    const { pathname } = useLocation();

    useEffect(() => {
        // Le decimos a la ventana del navegador que haga scroll a la posición X:0, Y:0 (arriba del todo)
        window.scrollTo(0, 0);
    }, [pathname]); 

    return null;
}